<template>
	<div class="mg-button-wrapper">
		<v-btn elevation="0"
			@click="$emit('click')"
			v-if="!circle"
			:class="'mg-button ' +
				(small ? 'mgButtonSmall ' : ' ')  +
				(alt ? 'alt ' : ' ') +
				(alt2 ? 'alt2 ' : ' ') +
				(outline ? 'outline ' : ' ') +
				(textOnly ? 'textOnly ' : ' ') +
				(fullWidth ? 'fullWidth ' : ' ') +
				(stacked ? 'mgButtonStacked ' : ' ') +
				(closerStack ? 'mgButtonCloserStack ' : ' ') +
				(noCaps ? 'mgButtonNoCaps ' : ' ')"
			:disabled="disabled"
			:variant="textOnly ? 'text' : undefined"
		>
			<v-row v-if="!small && !circle">
				<v-col v-if="icon || arrow || open || plus" class="leftIconCol" :cols="iconCols">
					<img v-if="!icon || !icon.startsWith('mdi-')" class="leftIcon" :src="icon ?? require('@/assets/transparent.png')" />
					<v-icon v-if="icon && icon.startsWith('mdi-')" :icon="icon" />
				</v-col>
				<v-col :class="(icon || arrow || open || plus ? 'textCol' : ' ')" :cols="(icon || arrow || open || plus) ? (12 - iconCols * 2) : undefined">
					{{text}}
				</v-col>
				<v-col v-if="arrow || open || icon || plus" class="rightIconCol" :cols="iconCols">
					<img v-if="arrow" :class="['arrow', 'rightIcon', !alt && !alt2 && !outline ? 'white-arrow' : '']" :src="(alt || alt2 || outline ? require('@/assets/arrow-right.png') : require('@/assets/light-arrow-right.png'))" />
					<img v-if="open" class="open rightIcon" :src="(alt || alt2 || outline ? require('@/assets/chevron-down.png') : require('@/assets/chevron-down.png'))"/>
					<img v-if="plus" class="plus rightIcon" :src="(alt || alt2 || outline ? require('@/assets/plus-inverted.png') : require('@/assets/plus-inverted.png'))"/>
				</v-col>
			</v-row>
			<div v-if="small">
				{{ text }}
			</div>
		</v-btn>

		<v-btn @click="$emit('click')" v-if="circle" :color="color ? color : (alt ? '#E0C5C8' : '#281C3B')" :icon="icon" :density="small ? 'compact': 'default'"></v-btn>
	</div>
</template>

<script>
export default {
	name: "MGButton",
	props: {
		text: {
			type: String,
			default: ''
		},
		outline: {
			type: Boolean,
			default: false
		},
		small: {
			type: Boolean,
			default: false
		},
		arrow: {
			type: Boolean,
			default: false
		},
		alt: {
			type: Boolean,
			default: false
		},
		alt2: {
			type: Boolean,
			default: false
		},
		icon: {
			type: String,
			default: ''
		},
		open: {
			type: Boolean,
			default: false
		},
		circle: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		fullWidth: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: ''
		},
		stacked: {
			type: Boolean,
			default: false
		},
		closerStack: {
			type: Boolean,
			default: false
		},
		textOnly: {
			type: Boolean,
			default: false
		},
		noCaps: {
			type: Boolean,
			default: false
		},
		plus: {
			type: Boolean,
			default: false
		},
		leftIconSize: {
			type: [String, Number],
			default: 30
		}
	},
	emits: ['click'],
	data() {
		return{
		}
	},
	computed: {
		iconCols() {
			// Return 1 if text is longer than 25 characters, otherwise 2
			return this.text && this.text.length > 26 ? 1 : 2;
		}
	},
	methods: {
		onLoad() {
	
		}
	},
	mounted: function() { this.onLoad(); }
}
</script>

<style scoped>

.mg-button-wrapper {
	display: contents;
}

.fullWidth {
	width: 100% !important;
}

.mgButtonSmall
{
	width: unset !important;
	height: 40px !important;
}

.mgButtonNoCaps {
	text-transform: none !important;
}

.mgButtonStacked
{
	margin-top: 15px !important;
}

.mgButtonCloserStack
{
	margin-top: 5px !important;
}

.rightIconCol {
	margin-top:auto;
	margin-bottom:auto;
}

.rightIcon {
	margin-top:auto;
	margin-bottom:auto;
	margin-left: auto;
	margin-right: -8px;
}

.leftIconCol {
	padding-left: 0px;
	margin-left: -8px;
	margin-top:auto;
	margin-bottom:auto;
}

.arrowCol {
	padding-right: 4px;
	margin-top:auto;
	margin-bottom:auto;
}

.leftIcon {
	width: v-bind("(leftIconSize || 30) + 'px'");
}

.textCol {
	margin-top:auto;
	margin-bottom:auto;
	letter-spacing: normal !important;
}

.alt {
	background: linear-gradient(243.52deg, #FCE5D4 18.85%, #E0C5C8 81.37%) !important;
	color: var(--text-color) !important;
}

.alt2 {
	background: #41365508 !important;
	color: var(--text-color) !important;
}

.arrow {
	height: 14px;
	width: 18px;
	margin-top: 5px;
}

.white-arrow {
	filter: brightness(0) invert(1);
}

.open {
	height: 8px;
}

.plus {
	height: 30px;
	width: 30px;
	margin-top: 5px;
	margin-left: 5px;
}

.mg-button,
.mgButtonSmall,
.textCol {
letter-spacing: normal !important;
}

/* Responsive: hide left icon on small screens */
@media (max-width: 350px) {
	.leftIconCol {
		display: none !important;
	}
}

/* Responsive: hide right icon on very small screens */
@media (max-width: 350px) {
	.rightIconCol {
		display: none !important;
	}
}

</style>